import { EDisplays, selectDisplay } from '@/context/display';
import { useAppSelector } from '@/context/storeHooks';

import { Business } from './Displays/Business';
import {
    EmploymentIneligible,
    IncomeIneligible,
    Ineligible,
    NoIncomeIneligible,
} from './Displays/IneligiblePage';
import { NovatedApproved } from './Displays/NovatedApproved';
import { PreApprovalAnimation } from './Displays/PreApprovalAnimation';
import { SupportingDocs } from './Displays/SupportingDocs';
import { TestDriveIndicativelyReferred } from './Displays/TestDriveIndicativelyReferred';
import { TestDriveLandingPage } from './Displays/TestDriveLandingPage';
import { YourScores } from './Displays/YourScores/YourScores';
import {
    AssetsAndLiabilities,
    BasicDetails,
    CampaignLanding,
    Employment,
    Expense,
    Identification,
    Income,
    IndicativelyApproved,
    IndicativelyDeclined,
    IndicativelyReferred,
    Loan,
    ManualVehicle,
    MultiAssetJourney,
    NoLenderHome,
    None,
    OcrAnimation,
    OcrSummary,
    QuickCalculator,
    Seller,
    ServicingFailure,
    ServicingSuccess,
    ServicingTechnicalFailure,
    StoreSelector,
    TestDriveAgreement,
    TestDriveOcrSummary,
    TestDriveReady,
    TruckstopLandingPage,
    Vehicle,
} from './Displays';

function DisplayScreen(): JSX.Element {
    const display = useAppSelector(selectDisplay);

    switch (display) {
        case null:
            return <div />;
        case EDisplays.BASIC:
            return <BasicDetails />;
        case EDisplays.ASSETS_AND_LIABILITIES:
            return <AssetsAndLiabilities />;
        case EDisplays.INCOME:
            return <Income />;
        case EDisplays.STORE_SELECTOR:
            return <StoreSelector />;
        case EDisplays.EXPENSE:
            return <Expense />;
        case EDisplays.LOAN:
            return <Loan />;
        case EDisplays.SELLER:
            return <Seller />;
        case EDisplays.INELIGIBLE:
            return <Ineligible />;
        case EDisplays.EMPLOYMENTINELIGIBLE:
            return <EmploymentIneligible />;
        case EDisplays.INCOMEINELIGIBLE:
            return <IncomeIneligible />;
        case EDisplays.NOINCOMEINELIGIBLE:
            return <NoIncomeIneligible />;
        case EDisplays.NOVATED_APPROVED:
            return <NovatedApproved />;
        case EDisplays.SERVICING_SUCCESS:
            return <ServicingSuccess />;
        case EDisplays.SERVICING_TECHNICAL_FAILURE:
            return <ServicingTechnicalFailure />;
        case EDisplays.SERVICING_FAILURE:
            return <ServicingFailure />;
        case EDisplays.IDENTIFICATION:
            return <Identification />;
        case EDisplays.VEHICLE:
            return <Vehicle />;
        case EDisplays.OCR_SUMMARY:
            return <OcrSummary />;
        case EDisplays.INDICATIVELY_REFERRED:
            return <IndicativelyReferred />;
        case EDisplays.INDICATIVELY_DECLINED:
            return <IndicativelyDeclined />;
        case EDisplays.INDICATIVELY_APPROVED:
            return <IndicativelyApproved />;
        case EDisplays.EMPLOYMENT:
            return <Employment />;
        case EDisplays.SUPPORTING_DOCS:
            return <SupportingDocs />;
        case EDisplays.MANUAL_VEHICLE:
            return <ManualVehicle />;
        case EDisplays.BUSINESS:
            return <Business />;
        case EDisplays.OCR_ANIMATION:
            return <OcrAnimation />;
        case EDisplays.PREPPROVAL_ANIMATION:
            return <PreApprovalAnimation />;
        case EDisplays.YOUR_SCORES:
            return <YourScores />;
        case EDisplays.QUICK_CALCULATOR:
            return <QuickCalculator />;
        case EDisplays.MULTI_ASSET_JOURNEY:
            return <MultiAssetJourney />;
        case EDisplays.CAMPAIGN_LANDING:
            return <CampaignLanding />;

        // ***** Test Drive ***** //
        case EDisplays.TEST_DRIVE_LANDING_PAGE:
            return <TestDriveLandingPage />;
        case EDisplays.TRUCKSTOP_LANDING_PAGE:
            return <TruckstopLandingPage />;
        case EDisplays.NO_LENDER_HOME:
            return <NoLenderHome />;
        case EDisplays.TEST_DRIVE_OCR_SUMMARY:
            return <TestDriveOcrSummary />;
        case EDisplays.TEST_DRIVE_AGREEMENT:
            return <TestDriveAgreement />;
        case EDisplays.TEST_DRIVE_READY:
            return <TestDriveReady />;
        case EDisplays.TEST_DRIVE_INDICATIVELY_REFERRED:
            return <TestDriveIndicativelyReferred />;
        default:
        case EDisplays.NONE:
            return <None />;
    }
}

export { DisplayScreen };
